/**
 * My Work Formatters & Constants
 * Helper utilities for time calculations, durations, and status configurations.
 */

export const MY_WORK_STATUSES = [
    { key: 'Backlog', label: 'Backlog / Upcoming', color: '#2563eb', bgClass: 'bg-blue-600', dotClass: 'bg-blue-600' },
    { key: 'In Progress', label: 'In Progress', color: '#22c55e', bgClass: 'bg-green-500', dotClass: 'bg-green-500' },
    { key: 'Under Review', label: 'Under Review', color: '#f59e0b', bgClass: 'bg-amber-500', dotClass: 'bg-amber-500' },
    { key: 'On Hold', label: 'On Hold', color: '#f43f5e', bgClass: 'bg-rose-500', dotClass: 'bg-rose-500' },
    { key: 'Completed', label: 'Completed', color: '#94a3b8', bgClass: 'bg-slate-400', dotClass: 'bg-slate-400' },
];

/**
 * Format total minutes or milliseconds into human-readable format e.g. "36h 30m" or "40h"
 */
export function formatMinutesToDuration(totalMinutes) {
    if (!totalMinutes || isNaN(totalMinutes) || totalMinutes <= 0) return '0h';
    const mins = Math.round(totalMinutes);
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;

    if (hours === 0) return `${remainingMins}m`;
    if (remainingMins === 0) return `${hours}h`;
    return `${hours}h ${remainingMins}m`;
}

/**
 * Parse estimated string (e.g. "36h 30m", "8h", "2.5h", "45m") to minutes
 */
export function parseEstimatedStringToMinutes(str) {
    if (!str || typeof str !== 'string') return 0;
    let totalMinutes = 0;
    const hoursMatch = str.match(/(\d+(?:\.\d+)?)h/i);
    const minutesMatch = str.match(/(\d+)m/i);

    if (hoursMatch) {
        totalMinutes += parseFloat(hoursMatch[1]) * 60;
    }
    if (minutesMatch) {
        totalMinutes += parseInt(minutesMatch[1], 10);
    }
    return Math.round(totalMinutes);
}

/**
 * Normalizes task status into one of the 5 canonical overview statuses
 */
export function normalizeTaskStatus(status) {
    if (!status) return 'Backlog';
    const s = String(status).trim().toLowerCase();
    if (s === 'in progress' || s === 'working' || s === 'active') return 'In Progress';
    if (s === 'under review' || s === 'review' || s === 'in review' || s === 'qa') return 'Under Review';
    if (s === 'on hold' || s === 'hold' || s === 'blocked') return 'On Hold';
    if (s === 'completed' || s === 'done' || s === 'closed' || s === 'close') return 'Completed';
    return 'Backlog';
}
